/*
 * Zendesk utils
 */

import axios from 'axios'
import ENV from '@src/env'

const zendesk = function() {
  return {
    methods: {
      createTicket: function(ticket) {
        const zendeskEnv = this.userEnv === 'DEV' ? 'DEV' : 'CO'
        const baseZendesk = `${ENV.rappi.url[zendeskEnv]}/rappi-zendesk/tickets?zendesk=user`
        const submitter_id = null // eslint-disable-line
        const requester_id = null // eslint-disable-line

        ticket = Object.assign({}, ticket, {
          submitter_id,
          requester_id,
        })
        return axios.post(`${baseZendesk}`, ticket)
      },
      requestFlowAtion: function({ token, body }) {
        const url = `${
          ENV.rappi.url[this.userEnv]
        }/api/support-flows/flow-actions/execute`
        return axios.post(url, body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      },
      formatProductsComment: function(products) {
        return products
          .map(p => {
            return `
            Product ID: ${p.product_id}
            Product Name: ${p.name}
            Product Price: ${p.unit_price}
            Quantity: ${p.complainedUnits || p.quantity}
          `
          })
          .toString()
      },
    },
  }
}

export default zendesk
